"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
var React = __importStar(require("react"));
var bind_1 = __importDefault(require("classnames/bind"));
var styles = __importStar(require("./styles.modules.css"));
var text_1 = require("../text");
var cx = bind_1.default.bind(styles);
var defaultProps = {
    style: "regular",
};
var Loading = function (props) {
    var _a;
    var className = props.className, style = props.style, label = props.label;
    var className_ = cx((_a = {
            loading: true
        },
        _a[className] = className,
        _a[style] = true,
        _a));
    return (React.createElement("div", { className: className_ },
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", preserveAspectRatio: "xMidYMid" },
            React.createElement("circle", { cx: "84", cy: "50", r: "2.92972" },
                React.createElement("animate", { attributeName: "r", values: "10;0;0;0;0", keyTimes: "0;0.25;0.5;0.75;1", keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1", calcMode: "spline", dur: "2s", repeatCount: "indefinite", begin: "0s" }),
                React.createElement("animate", { attributeName: "cx", values: "84;84;84;84;84", keyTimes: "0;0.25;0.5;0.75;1", keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1", calcMode: "spline", dur: "2s", repeatCount: "indefinite", begin: "0s" })),
            React.createElement("circle", { cx: "74.0389", cy: "50", r: "10" },
                React.createElement("animate", { attributeName: "r", values: "0;10;10;10;0", keyTimes: "0;0.25;0.5;0.75;1", keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1", calcMode: "spline", dur: "2s", repeatCount: "indefinite", begin: "-1s" }),
                React.createElement("animate", { attributeName: "cx", values: "16;16;50;84;84", keyTimes: "0;0.25;0.5;0.75;1", keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1", calcMode: "spline", dur: "2s", repeatCount: "indefinite", begin: "-1s" })),
            React.createElement("circle", { cx: "40.0389", cy: "50", r: "10" },
                React.createElement("animate", { attributeName: "r", values: "0;10;10;10;0", keyTimes: "0;0.25;0.5;0.75;1", keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1", calcMode: "spline", dur: "2s", repeatCount: "indefinite", begin: "-0.5s" }),
                React.createElement("animate", { attributeName: "cx", values: "16;16;50;84;84", keyTimes: "0;0.25;0.5;0.75;1", keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1", calcMode: "spline", dur: "2s", repeatCount: "indefinite", begin: "-0.5s" })),
            React.createElement("circle", { cx: "16", cy: "50", r: "7.07028" },
                React.createElement("animate", { attributeName: "r", values: "0;10;10;10;0", keyTimes: "0;0.25;0.5;0.75;1", keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1", calcMode: "spline", dur: "2s", repeatCount: "indefinite", begin: "0s" }),
                React.createElement("animate", { attributeName: "cx", values: "16;16;50;84;84", keyTimes: "0;0.25;0.5;0.75;1", keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1", calcMode: "spline", dur: "2s", repeatCount: "indefinite", begin: "0s" })),
            React.createElement("circle", { cx: "16", cy: "50", r: "0" },
                React.createElement("animate", { attributeName: "r", values: "0;0;10;10;10", keyTimes: "0;0.25;0.5;0.75;1", keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1", calcMode: "spline", dur: "2s", repeatCount: "indefinite", begin: "0s" }),
                React.createElement("animate", { attributeName: "cx", values: "16;16;16;50;84", keyTimes: "0;0.25;0.5;0.75;1", keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1", calcMode: "spline", dur: "2s", repeatCount: "indefinite", begin: "0s" }))),
        label && React.createElement(text_1.Text, null, label)));
};
exports.Loading = Loading;
Loading.defaultProps = defaultProps;
exports.default = Loading;
//# sourceMappingURL=loading.js.map